import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectWorksheet } from 'services/worksheet/selectors';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { OwnProps } from './index';

const selectPageIndex = (
    state: AppState,
    props: OwnProps
): WorksheetPageIndex => props.pageIndex;

const selectSprayWorksheetEquipmentSet = createDeepEqualSelector(
    selectWorksheet,
    selectPageIndex,
    (sprayWorksheetState, index) =>
        get(sprayWorksheetState, ['pages', index, 'sprayEquipmentSet'])
);

const selectSprayWorksheetEquipmentSetName = createDeepEqualSelector(
    selectSprayWorksheetEquipmentSet,
    (equipmentSet) => get(equipmentSet, 'name', '')
);

const makeSelectSprayWorksheetEquipmentSetName =
    (): typeof selectSprayWorksheetEquipmentSetName =>
        selectSprayWorksheetEquipmentSetName;

const selectSprayWorksheetEquipmentSetTankVolume = createDeepEqualSelector(
    selectSprayWorksheetEquipmentSet,
    (equipmentSet) => get(equipmentSet, 'tankVolume', '')
);

const makeSelectSprayWorksheetEquipmentSetTankVolume =
    (): typeof selectSprayWorksheetEquipmentSetTankVolume =>
        selectSprayWorksheetEquipmentSetTankVolume;

export {
    selectPageIndex,
    makeSelectSprayWorksheetEquipmentSetName,
    makeSelectSprayWorksheetEquipmentSetTankVolume
};
